module.exports = __webpack_public_path__ + "images/logo-29b00238.png";